module.exports = __webpack_public_path__ + "static/comic-green-background-small-2ee41307d5105ec269ee23bf5b861029.svg";